"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dom_node_type_1 = require("dom-node-type");

function getTextNodes(node) {
  var textNodes = [];

  if (dom_node_type_1.isTextNode(node)) {
    textNodes.push(node);
    return textNodes;
  }

  var iterator = document.createNodeIterator(node, NodeFilter.SHOW_TEXT, null, false);
  var textNode = iterator.nextNode();

  while (textNode) {
    textNodes.push(textNode);
    textNode = iterator.nextNode();
  }

  return textNodes;
}

exports.getTextNodes = getTextNodes;

function isTextDivisionNode(node) {
  return dom_node_type_1.isElementNode(node) && (dom_node_type_1.isSelfClosingNode(node) || ['SVG'].indexOf(node.tagName.toUpperCase()) !== -1);
}

function getTextNodesDividedByBlock(root) {
  var stack = [];
  var pendStack = [];
  var result = [];

  if (!root.firstChild || !dom_node_type_1.isBlockNode(root)) {
    return result;
  }

  stack.push({
    node: root.firstChild,
    parentBlock: root
  });
  var latestParentBlock = root;
  result.push([]);

  while (stack.length > 0) {
    var _a = stack.pop(),
        node = _a.node,
        parentBlock = _a.parentBlock;

    var firstChild = node.firstChild,
        nextSibling = node.nextSibling,
        parentNode = node.parentNode;

    if (latestParentBlock !== parentBlock && result[result.length - 1].length !== 0) {
      result.push([]);
    }

    latestParentBlock = parentBlock;

    if (dom_node_type_1.isTextNode(node)) {
      result[result.length - 1].push(node);
    } else if (isTextDivisionNode(node) && result[result.length - 1].length !== 0) {
      result.push([]);
    }

    if (firstChild) {
      stack.push({
        node: firstChild,
        parentBlock: dom_node_type_1.isBlockNode(node) ? node : parentBlock
      });

      if (nextSibling) {
        pendStack.push({
          node: nextSibling,
          parentBlock: dom_node_type_1.isBlockNode(parentNode) ? parentNode : parentBlock
        });
      }
    } else if (nextSibling) {
      stack.push({
        node: nextSibling,
        parentBlock: dom_node_type_1.isBlockNode(parentNode) ? parentNode : parentBlock
      });
    } else if (pendStack.length > 0) {
      stack.push(pendStack.pop());
    }
  }

  return result;
}

exports.getTextNodesDividedByBlock = getTextNodesDividedByBlock;

function getTextWithRanges(textNodes) {
  var ranges = [];
  var text = '';

  for (var i = 0; i < textNodes.length; i++) {
    var textNode = textNodes[i];
    ranges.push({
      textNode: textNode,
      range: {
        start: text.length,
        end: text.length + textNode.nodeValue.length
      }
    });
    text = "" + text + textNode.nodeValue;
  }

  return {
    text: text,
    ranges: ranges
  };
}

exports.getTextWithRanges = getTextWithRanges;